import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Rx';

import { Alarma } from '../alarmas/alarma';

import myGlobals = require('../config');

@Injectable()
export class AlarmaService {

  private alarmaUrl = myGlobals.default.BASE_URL + '/alarma/';  // URL to web api

  constructor(private http: Http) { }

  //Obtener todos los alarmas habilitados para el usuario
  getAlarmas() {
    return this.http.get(this.alarmaUrl)
      .map((response) => response.json());
  }

  //Obtener un alarma
  getAlarma(_id: string): Observable<Alarma> {
    return this.http.get(this.alarmaUrl + _id)
      .map((response) => response.json());
  }


  save(alarma: Alarma): Observable<Alarma> {
    if (alarma._id) {
      return this.put(alarma);
    }
    //Seteo estado activo
    alarma.estado = true;
    return this.post(alarma);
  }

  //Desactivar alarma
  delete(alarma: Alarma) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    let url = `${this.alarmaUrl}/${alarma._id}`;

    return this.http
      .delete(url, { headers: headers })
      .map((response) => response.json());
  }

  // Agregar nueva alarma
  private post(alarma: Alarma): Observable<Alarma> {
    let headers = new Headers({
      'Content-Type': 'application/json;charset=UTF-8'
    });
    headers.append('dataType', 'json');
    console.log(alarma);
    console.log(JSON.stringify(alarma));
    var alarmaStr = JSON.stringify(alarma);
    return this.http
      .post(this.alarmaUrl, alarmaStr, { headers: headers })
      .map((response) => response.json());
  }

  // Actualizar alarma
  private put(alarma: Alarma) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    let url = `${this.alarmaUrl}/${alarma._id}`;

    return this.http
      .put(url, JSON.stringify(alarma), { headers: headers })
      .map((response) => response.json());
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/abmalarmas/alarma.service.ts